// @ngInject
function NewInventoryDialogService($uibModal, LocationsApiService, InventoryingApiService, StockApiService) {

    return {
        showDialog: showDialog
    };

    function showDialog() {

        var modalDefaults = {
            backdrop: 'static',
            keyboard: true,
            controller: 'NewInventoryDialogServiceController as vm',
            templateUrl: 'services/dialogs/newInventoryDialog/newInventoryDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            locations: function() {
                return StockApiService.getFilteredLocations();
            },
            inventoryTypes: function() {
                return StockApiService.getInventoryTypes();
            },
            mainGroups: function() {
                return StockApiService.getMainGroups();
            },
            brands: function() {
                return StockApiService.getBrands();
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function NewInventoryDialogServiceController($uibModalInstance, locations, inventoryTypes, brands, ResourcesService, InventoryingApiService, mainGroups) {
    var vm = this;
    var currentTime = getCurrentTimeRoundedToNearestHour();

    vm.locations = locations;
    vm.inventoryTypes = inventoryTypes;
    vm.mainGroups = insertEmptyMainGroupFirst(mainGroups);
    vm.brands = insertEmptyBrandFirst(brands);

    vm.isShowingScanningForm = false;
    vm.toggleScanningForm = toggleScanningForm;
    vm.scannedBarcodes = "";

    vm.locationChanged = locationChanged;
    vm.inventoryTypeChanged = inventoryTypeChanged;
    vm.mainGroupChanged = mainGroupChanged;
    vm.brandChanged = brandChanged;
    vm.save = save;
    vm.closeModal = closeModal;

    vm.newInventoryRequestData = {
        inventoryDescription: "",
        inventoryDate: currentTime,
        brand: { id: 0, brandDescription: ' ' },
        itemGroup: { id: 0, itemGroupLongName: ' '},
        inventoryType: { id: 0 },
        location: { id: 0 },
        itemGroups: [],
        brands:[]
    };

    // testing support for mulitple main groups
    vm.newInventoryRequestData.mainGroups = [];

    function getCurrentTimeRoundedToNearestHour() {
        var timeNonUtc = new Date();
        var time = new Date();
        time.setSeconds(0);
        time.setMilliseconds(0);

        if (time.getMinutes() < 30) {
            time.setMinutes(0);
        } else {
            time.setMinutes(0);
            if (time.getHours() <= 22) {
                time.setHours(time.getHours() + 1);
            } else {
                time.setHours(23);
            }
        }
        return time;
    }

    function closeModal(args) {
        $uibModalInstance.close(args);
    }

    function save() {
        $uibModalInstance.startLoadingSpinner();
        InventoryingApiService.createInventory(vm.newInventoryRequestData).then(function(response) {
            console.log("Success, id:" + response.data.id);
            vm.closeModal({ success: true, inventoryItem: response.data });
        }, function(error) {
            handleError(error);
        }).finally(function() {
            $uibModalInstance.stopLoadingSpinner();
        });
    }

    function insertEmptyMainGroupFirst(mainGroups) {
        var emptyMainGroup = {
            id: 0,
            mainGroupDescription: ' '
        };
        var newArr = [];
        newArr.push(emptyMainGroup);
        newArr = newArr.concat(mainGroups);
        return newArr;
    }

    function insertEmptyBrandFirst(brands) {
        var emptyBrand = {
            id: 0,
            brandDescription: ' '
        };
        var newArr = [];
        newArr.push(emptyBrand);
        newArr = newArr.concat(brands);
        return newArr;
    }

    function toggleScanningForm() {
        if (!vm.isShowingScanningForm) {
            vm.isShowingScanningForm = true;
        } else {
            vm.isShowingScanningForm = false;
            vm.scannedBarcodes = "";
        }
    }

    function locationChanged(sender) {
        vm.newInventoryRequestData.location = sender.selectedItem;
    }

    function inventoryTypeChanged(sender) {
        vm.newInventoryRequestData.inventoryType = sender.selectedItem;
    }

    function mainGroupChanged(sender) {
        vm.newInventoryRequestData.mainGroup = sender.selectedItem;
    }

    function brandChanged(sender) {
        vm.newInventoryRequestData.brand = sender.selectedItem;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }

}

angular
    .module('services.dialogs.newInventoryDialog', [])
    .service('NewInventoryDialogService', NewInventoryDialogService)
    .controller('NewInventoryDialogServiceController', NewInventoryDialogServiceController);
